import { useState } from "react";
import DashboardService from "../services/api/dashboard-service"


const useDashboard = () => {

    const [bookingCount, setBookingCount] = useState(null);
    const [vehicleCount, setVehicleCount] = useState(null);
    const [gatepassCount, setGatepassCount] = useState(null);
    const [accessLogs, setAccessLogs] = useState(null);
    const [error, setError] = useState(null);
    const [isAccessLogsLoading, setIsAccessLogsLoading] = useState(false);
    const [isGatepassLoading, setIsGatepassLoading] = useState(false);
    const [isVehicleLoading, setIsVehicleLoading] = useState(false);
    const [isBookingLoading, setIsBookingLoading] = useState(false);
    const [isContainerLoading, setIsContainerLoading] = useState(false);
    const [containerCount, setContainerCount] = useState(null);
    const [userCount, setUserCount] = useState(null);

    const [bookingGraph, setBookingGraph] = useState(null);
    const [gatepassGraph, setGatepassGraph] = useState(null)
    const [vehicleGraph, setVehicleGraph] = useState(null);
    const [containerGraph, setContainerGraph] = useState(null);
    const [orgName, setOrgName] = useState(null);
    const [purposeNames, setPurposeNames] = useState(null);


    const countAccessLogs = async (parameters) => {
        try {
            setIsAccessLogsLoading(true);
            const response = await DashboardService.countAccessLogs(parameters);
            setAccessLogs(response.data.data);
            setIsAccessLogsLoading(false);
            return response.data.data;
        } catch (error) {
            setIsAccessLogsLoading(false);
           console.log("Error fetching access logs count:", error);
            setError(error.response.data.error);
        }
    }

    const countGatepass = async (parameters) => {
        try {
            setIsGatepassLoading(true);
            const response = await DashboardService.countGatepass(parameters);
            setIsGatepassLoading(false);
            setGatepassCount(response.data.data);
            return response.data.data;
        } catch (error) {
            setIsGatepassLoading(false);
           console.log("Error fetching gatepass count:", error);
            // throw error;
        }
    }

    const countVehicle = async (parameters) => {
        try {
            setIsVehicleLoading(true);
            const response = await DashboardService.countVehicle(parameters);
            setVehicleCount(response.data.data);
            setIsVehicleLoading(false);
            return response.data.data;
        } catch (error) {
            setIsVehicleLoading(false);
           console.log("Error fetching vehicle count:", error);
            // throw error;
        }
    }

    const countBooking = async (parameters) => {
        try {
            setIsBookingLoading(true);
            const response = await DashboardService.countBooking(parameters);
            setBookingCount(response.data.data);
            setIsBookingLoading(false);
            return response.data.data;
        } catch (error) {
            setIsBookingLoading(false);
           console.log("Error fetching booking count:", error);
            // throw error;
        }
    }

    const countContainer = async (parameters) => {
        try {
            setIsContainerLoading(true);
            const response = await DashboardService.countContainer(parameters);
            setContainerCount(response.data.data);
            setIsContainerLoading(false);
            return response.data.data;
        } catch (error) {
            setIsContainerLoading(false);
           console.log("Error fetching container count:", error);
            // throw error;
        }
    }

    const getUserCount = async (parameters) => {
        try {
            const response = await DashboardService.getUserCount(parameters);
            setUserCount(response.data.data);
            return response.data.data;
        } catch (error) {
           console.log("Error fetching user count:", error);
            // throw error;
        }
    }

    const bookingAnalytics = async (parameters) => {
        try {
            const response = await DashboardService.bookingAnalytics(parameters);
            setBookingGraph(response.data.data);
            return response.data.data;
        } catch (error) {
           console.log("Error fetching bookingAnalytics:", error);
            // throw error;
        }
    }

    const gatepassAnalytics = async (parameters) => {
        try {
            const response = await DashboardService.gatepassAnalytics(parameters);
            setGatepassGraph(response.data.data);
            return response.data.data;
        } catch (error) {
           console.log("Error fetching gatepass:", error);
            // throw error;
        }
    }

    const vehicleAnalytics = async (parameters) => {
        try {
            const response = await DashboardService.vehicleAnalytics(parameters);
            setVehicleGraph(response.data.data);
            return response.data.data;
        } catch (error) {
           console.log("Error fetching setVehicleGraph:", error);
            // throw error;
        }
    }

    const containerAnalytics = async (parameters) => {
        try {
            const response = await DashboardService.containerAnalytics(parameters);
            setContainerGraph(response.data.data);
            return response.data.data;
        } catch (error) {
           console.log("Error fetching containerAnalytics:", error);
            // throw error;
        }
    }

    const getOrgNameByOrgUID = async (parameters) => {
        try {
            const response = await DashboardService.getOrgNameByOrgUID(parameters);
            const orgNameMap = response.data.data.org_uids || {};
            setOrgName(orgNameMap);
            console.log("Organization Name map:", orgNameMap);
            return orgNameMap;
        } catch (error) {
            console.log("Error fetching organization name:", error);
        }
    };

    const bookingNameByPurpose = async (parameters) => {
        try {
            const response = await DashboardService.bookingNameByPurpose(parameters);
            const purposeNamesMap = response.data.data || {};
            setPurposeNames(purposeNamesMap);

            console.log("Purpose names map:", purposeNamesMap);
            return purposeNamesMap;
        }
        catch (error) {
            console.log("Error fetching booking names by purpose:", error);
        }
    }

   
    return {
        countAccessLogs,
        accessLogs,
        error,
        isAccessLogsLoading,

        countGatepass,
        gatepassCount,
        isGatepassLoading,

        countVehicle,
        vehicleCount,
        isVehicleLoading,

        countBooking,
        bookingCount,
        isBookingLoading,

        countContainer,
        containerCount,
        isContainerLoading,

        getUserCount,
        userCount,

        bookingAnalytics,
        bookingGraph,

        gatepassAnalytics,
        gatepassGraph,

        containerAnalytics,
        containerGraph,

        vehicleAnalytics,
        vehicleGraph,

        getOrgNameByOrgUID,
        orgName,

        bookingNameByPurpose,
        purposeNames,
   
    }
}

export default useDashboard